export {
  default as Text,
  RegularText,
  SemiBoldText,
  BoldText,
  BoldItalicText,
  ExtraBoldText,
  FontWeight,
  QuicksandLight,
  QuicksandRegular,
  QuicksandMedium,
  QuicksandSemiBold,
  QuicksandBold,
} from './Text';
